import { Theme } from '@mui/material/styles'

export const getStyles = (theme: Theme) => ({
  formInfoLabel: {
    fontSize: '16px',
  },

  subFormInfoLabel: {
    fontSize: '12px',
    marginTop: theme.spacing(0.3),
  },
})

/**
 * Builds the `sx` objects for a custom field card.
 *
 * Under the Tidal theme the card is a plain bottom-margined surface. Otherwise
 * its corners are rounded according to its position in the list, so
 * `getPaperSx` applies position-dependent border radii only in that state.
 *
 * `props` holds the theme-varying values that are not `sx`, because they select
 * a component prop rather than a CSS value.
 *
 * @param theme The active MUI theme.
 * @param isTidalThemeActive Whether the Tidal theme is active.
 */
export const getCardStyles = (theme: Theme, isTidalThemeActive: boolean) => ({
  getPaperSx: (position: 'first' | 'last' | 'common') => ({
    mb: 1.5,
    ...(isTidalThemeActive
      ? {}
      : position === 'common'
        ? { borderRadius: 0 }
        : position === 'first'
          ? { borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }
          : { borderTopLeftRadius: 0, borderTopRightRadius: 0 }),
  }),

  checkboxWrapper: isTidalThemeActive ? { px: 2 } : {},

  label: {
    mb: 1,
    color: isTidalThemeActive ? undefined : theme.palette.text.primary,
  },

  requiredText: {
    color: isTidalThemeActive ? undefined : theme.palette.text.primary,
    letterSpacing: isTidalThemeActive ? undefined : 0.15,
  },

  props: {
    labelVariant: isTidalThemeActive ? ('h6' as const) : ('subtitle1' as const),
  },
})

/**
 * Builds the `sx` objects for the custom fields section.
 *
 * Covers the section's width and padding, its heading row, and the two buttons
 * whose casing and elevation differ by theme.
 *
 * @param theme The active MUI theme.
 * @param isTidalThemeActive Whether the Tidal theme is active.
 */
export const getSectionStyles = (
  theme: Theme,
  isTidalThemeActive: boolean,
) => ({
  container: {
    pb: isTidalThemeActive ? 3 : 2,
    maxWidth: isTidalThemeActive ? 766 : 700,
  },

  headerRow: { mt: isTidalThemeActive ? undefined : 3, mb: 2 },

  manageFieldsButton: isTidalThemeActive
    ? { textTransform: 'none' as const }
    : {},

  launchIcon: { marginLeft: theme.spacing(1), fontSize: '20px' },

  reorderButton: {
    textTransform: isTidalThemeActive ? ('none' as const) : undefined,
    mb: 1.5,
  },

  props: {
    headingVariant: isTidalThemeActive ? ('h5' as const) : ('h6' as const),
    manageFieldsLabel: isTidalThemeActive
      ? 'Manage custom fields'
      : 'Manage Custom fields',
  },
})
